<template>
    <div :id="'radio--' + component_id">
        <div class="designeroption sbdoption" v-if="options_loaded && passed_filter && panel_required" data-designer-component-id="secured_by_design">
            <h3>Secured By Design</h3>
            <div class="stylesoption">
                <div class="radiooption stylesoption">
                    <span>Would you like to upgrade to SBD?</span>
                    <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                               :name="'radio_' + component_id"
                                                                               :value="option.value"/> {{ option.label }}</label></span>
                </div>

                <p>
                    To ensure your new door meets the stringent security standards specified by Secured by Design, your
                    specification will be as follows:
                </p>
                <p>
                    6.8mm toughened/laminated glazing, Prolinea spy hole, TS008 letter plate, security chain, ERA 2 hook door lock kit* with lever / lever & lever / pad handle.
                </p>

                <p>
                    * requires either a Yale 3* or Ultion 3* Gold Secure Diamond Cylinder.
                </p>

                <div class="features">
                    <span><img :src="'/images/s/multipoint-locking.png'" alt=""/><br>ERA 2 hook multi-point locking system</span>
                    <span><img :src="'/images/s/spyhole.png'" alt=""/><br>Prolinea Spy Hole</span>
                    <span><img :src="'/images/s/security-chain.png'" alt=""/><br>Security Chain</span>
                    <span><img :src="'/images/s/sbd-logos.jpg'" alt=""/></span>
                </div>
            </div>
        </div>
    </div>


</template>

<script type="text/ecmascript-6">
    import DesignerQuestionSecuredByDesign from "../DesignerQuestionSecuredByDesign.vue";

    export default {
        mixins: [
            DesignerQuestionSecuredByDesign
        ],
        props: {
            slab: {
                required: true,
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/secured-by-design?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
            panel_required() {
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'slab': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
